import './weekly.css';
import "./../Homepage.css";
import React, {useEffect, useState} from "react";

import linebot from './../photos/fp-cad/linebot.webp';
import linebotAngle from './../photos/fp-cad/linebotAngle.webp';
import linebotBottom from './../photos/fp-cad/linebotBottom.webp';
import linebotFront from './../photos/fp-cad/linebotFront.webp';
import linebotSide from './../photos/fp-cad/linebotSide.webp';
import week1circuit from './../photos/fp-cad/week1circuit.webp';
import week1pcb from './../photos/fp-cad/week1pcb.webp';
import week1top from './../photos/fp-cad/week1top.webp';
import week1side from './../photos/fp-cad/week1side.webp';
import wheelCAD from './../photos/fp-cad/wheelCAD.webp';
import IRCAD from './../photos/fp-cad/IRCAD.webp';
import microCAD from './../photos/fp-cad/microCAD.webp';

function Week1() {
  return (
    <div className="HP-module">
        <div className="HP-subtitle">Week 1</div>
        <div className="HP-flex">
          <div className="HP-body HP-half">
            During the first week of HTM(a)A we were tasked with designing something in CAD 
            software, specifically a potential final project idea. I have very linited experience with 2-D and 
            3-D CAD, so I emphasized learning different tools while I worked on my design. One of my favorite projects
            I've done here at MIT was my final project for my microcontroller project labratory, which was a line-following robot
            car. I loved building the project, but I never got it working quite as well as I would have liked, so for this project 
            I set out to design a better verion of the line robot as a potential project idea. <br /> <br />
            The line-following robot functions using two photodiodes, one on each side of the front of the car, paired with 
            two LEDs to sense the line underneath it. Light is emitted by the LED, which bounces off of the ground (and the line),
            and is reabsorbed by the photodiode. When a darker line is placed on a brighter surface, less light reflects off of the 
            line, so if one of the photodiodes absorbs more light than the other it means the line is no longer centered, and the 
            data can be used byu a microcontroller to determine how to turn the car. I started off by modeling this electrical circuit,
            along with the motors needed to power the car, in the diagram below.
          </div>
          <div className="HP-photoContent HP-half">
            <div className="HP-photoObject">
              <img src={linebot} className="HP-medPhoto" />
              <div className="HP-caption">My line-following robot from my previous class, and inspiration for this project</div>
            </div>
          </div>
        </div>
        <div className="HP-photoContainer">
          <img src={week1circuit} className="HP-largePhoto"/>
        </div>
        <div className="HP-body">
          Next, now knowing what electrical components I needed to include in my design, I did a rough sketch of the layout of 
          these components, both on a fabricated PCB for housing the electrical components as well as a whole car design with 
          appropriate placement of the motors, wheels, and sensors.
        </div>
        <div className="HP-photoContainer">
          <img src={week1pcb} className="HP-largePhoto"/>
          <img src={week1top} className="HP-largePhoto"/>
          <img src={week1side} className="HP-largePhoto"/>
        </div>
        <div className="HP-body">
          With my 2D inspiration for the new and improved robot car complete, I installed and configured FreeCAD to learn 
          how to model my design in three dimensions. I found my way around the different menus and tools using the demos 
          given to us and by experimenting on my own with the different capabilities of FreeCAD. One of the most useful 
          things in my design was the library of parts availiable to download and use on the internet. Using these importable 
          files I could add to my car things like microcontrollers, circuit components, and wheels without having to design 
          each part by hand. Some of the parts I used can be seen below: 
        </div>
        <div className="HP-photoContainer">
          <img src={wheelCAD} className="HP-medPhoto"/>
          <img src={microCAD} className="HP-medPhoto"/>
          <img src={IRCAD} className="HP-medPhoto"/>
        </div>
        <div className="HP-body">
          Putting together all of these parts along with several I made myself to house the components, I had build the first model 
          of the new and improved line-following robot car. The emphasis in the design was on maximizing component placement for 
          (planned) performance. To this end I made sure the body was small, with only 3 wheels so that it could turn very sharply. 
          Further, I placed the turning wheels as close to in line with the sensors at the front of the vehicle as possible, so that 
          when turning the sensors will stay over the line. I finally roughly modeled my PCB sketched above to be sat on top of the car 
          above the motors. I did not worry much about individual traces or wiring, as that would likely be done closer to fabrication of the 
          project. Finally, here are some renders of the final CAD drawing of my new and improved robot, enjoy!
        </div>
        <div className="HP-photoContainer">
          <img src={linebotAngle} className="HP-medPhoto"/>
          <img src={linebotBottom} className="HP-medPhoto"/>
          <img src={linebotFront} className="HP-medPhoto"/>
          <img src={linebotSide} className="HP-medPhoto"/>
        </div>
      </div>
  );
}

export default Week1;